"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _d = require("d3");
var _context;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "axis": "donut_chart-module__axis___Cag9O",
  "donut-normal": "donut_chart-module__donut-normal___VDklW",
  "donut-alert": "donut_chart-module__donut-alert____lxe9",
  "numerator": "donut_chart-module__numerator___ciCO_"
};
const tau = 2 * Math.PI; // http://tauday.com/tau-manifesto

function fractionCheck(props, propName, componentName) {
  const propTypes = {
    numerator: T.number.isRequired,
    denominator: T.number.isRequired
  };
  T.checkPropTypes(propTypes, props, propName, componentName);
  if (props.denominator <= 0) {
    return new Error('denominator cannot be less than or equal to zero');
  }
  if (props.numerator < 0) {
    return new Error('numerator cannot be less than zero');
  }
  if (props.numerator > props.denominator) {
    return new Error('nominator cannot be larger than the denominator');
  }
}

// Much of this was taking from this bl.ocks
// http://bl.ocks.org/mbostock/5100636I
class DonutChart extends _react.PureComponent {
  static propTypes = {
    numerator: fractionCheck,
    denominator: fractionCheck,
    mode: T.oneOf(['normal', 'alert']),
    width: T.number,
    height: T.number
  };
  static defaultProps = {
    mode: 'normal'
  };
  componentDidUpdate() {
    this.renderD3();
  }
  componentDidMount() {
    this.renderD3();
  }
  setRef = (0, _bind.default)(_context = this.setRef).call(_context, this);
  setRef(ref) {
    this.svg = ref;
    if (typeof this.props.svgRef === 'function') {
      this.props.svgRef(ref);
    }
  }
  get minDim() {
    return Math.min(this.props.width, this.props.height);
  }
  get radius() {
    return this.minDim / 2 * 0.9;
  }
  get fontSize() {
    const fontSize = this.props.fontSize ? this.props.fontSize : 0.4 * this.radius;
    return Math.min(fontSize, this.props.maxFontSize || Infinity);
  }
  createArc(thickness, radius = this.radius) {
    // Creates an arc without an end angle
    const innerRadius = radius - thickness / 2,
      outerRadius = radius + thickness / 2;
    return (0, _d.arc)().cornerRadius((outerRadius - innerRadius) / 2).innerRadius(innerRadius).outerRadius(outerRadius).startAngle(0);
  }
  renderD3() {
    const {
      width,
      height,
      numerator,
      denominator,
      mode
    } = this.props;
    const svg = (0, _d.select)(this.svg);

    // Remove older svg renders on data change or resizes
    svg.selectAll('*').remove();

    // Get the SVG container, and apply a transform such that the origin is the
    // center of the canvas. This way, we don’t need to position arcs individually.
    const g = svg.append('g').attr('transform', `translate(${width / 2}, ${height / 2})`);
    g.append('text').attr('x', 0).attr('y', 0.25 * this.fontSize).attr('font-size', this.fontSize).attr('text-anchor', 'middle').classed(styles.numerator, true).text(numerator);
    const donut = this.createArc(Math.max(4, this.minDim / 20));
    const axis = this.createArc(Math.max(1, this.minDim / 100));
    g.append('path').classed(styles.axis, true).datum({
      endAngle: tau
    }).attr('d', axis);
    g.append('path').classed(styles['donut-normal'], mode === 'normal').classed(styles['donut-alert'], mode === 'alert').datum({
      endAngle: Math.min(numerator / denominator, 1) * tau
    }).attr('d', donut);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("svg", {
      height: this.props.height,
      width: this.props.width,
      ref: this.setRef
    });
  }
}
exports.default = DonutChart;